import { c as _c } from "react/compiler-runtime";
import { differenceInDays, isPast } from 'date-fns';
import { useContext } from 'react';
import { parseDate } from 'utils/DateFormats';
import { useCurrencyContext } from '~/contexts/Currencies';
import JourneyDataContext from '~/contexts/JourneyDataContext';
import { useCurrentJourney } from '~/stores/journeyStore';
import type { AccommodationCard } from '~/types/Accommodation.types';
import type { StayTransformed } from '~/types/JourneyItem.types';
import { formatGBP } from '~/utils/currencyHelpers';
import { pricePerPerson } from '~/utils/paxHelpers';
export default function useJourneyData() {
  const $ = _c(72);
  const {
    user,
    futurePricingTiers,
    journeyType: t0,
    unavailableDates,
    urlPath
  } = useContext(JourneyDataContext);
  const journeyType = t0 === undefined ? "default" : t0;
  const journey = useCurrentJourney();
  const {
    details,
    items
  } = journey;
  const duration = user.duration;
  const total = details.totalPrice;
  const {
    convertPriceInGBP
  } = useCurrencyContext();
  let t1;
  if ($[0] !== convertPriceInGBP) {
    t1 = amount => convertPriceInGBP(amount) || formatGBP(amount);
    $[0] = convertPriceInGBP;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formatPrice = t1;
  const isTemplateOrBlueprint = journeyType === "asTemplate" || journeyType === "template";
  const adultCount = journeyType === "asTemplate" ? user.numberOfAdults : user.adult_count;
  const childCount = journeyType === "asTemplate" ? user.numberOfChildren ?? user.childAges?.length ?? 0 : user.child_count;
  const paxCount = adultCount + childCount;
  const roomCount = journeyType === "asTemplate" ? user.numberOfRooms : user.room_count;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let tripInDaysLabel;
  if ($[2] !== adultCount || $[3] !== details.startDate || $[4] !== details.tripInDays || $[5] !== duration || $[6] !== formatPrice || $[7] !== futurePricingTiers || $[8] !== isTemplateOrBlueprint || $[9] !== items || $[10] !== journey || $[11] !== journeyType || $[12] !== paxCount || $[13] !== roomCount || $[14] !== total || $[15] !== unavailableDates || $[16] !== urlPath || $[17] !== user) {
    const perPersonPrice = pricePerPerson(total, adultCount, user.childAges);
    let t18;
    if ($[35] !== details.startDate) {
      t18 = isPast(parseDate(details.startDate));
      $[35] = details.startDate;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    const isStartDateInPast = t18;
    tripInDaysLabel = details.tripInDays > duration ? `${duration} days (+${details.tripInDays - duration})` : `${details.tripInDays} days`;
    let t19;
    if ($[37] !== details.startDate) {
      t19 = differenceInDays(parseDate(details.startDate), new Date());
      $[37] = details.startDate;
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    const daysUntilTravel = t19;
    const isLastMinute = daysUntilTravel <= 31 && daysUntilTravel >= 0;
    let t20;
    if ($[39] !== items) {
      t20 = items.filter(_temp)?.some(_temp3);
      $[39] = items;
      $[40] = t20;
    } else {
      t20 = $[40];
    }
    const hasSurpriseMeAccommodation = t20;
    const isBookedTrip = journey.bookingInformation?.bookingStatus === "BOOKED" || journey.bookingInformation?.bookingStatus === "OUTSTANDING";
    t5 = user;
    t6 = futurePricingTiers;
    t7 = unavailableDates;
    t8 = urlPath;
    t9 = journeyType;
    t10 = isTemplateOrBlueprint;
    t11 = isStartDateInPast;
    t12 = isLastMinute;
    t13 = isBookedTrip;
    t14 = hasSurpriseMeAccommodation;
    t15 = paxCount;
    t16 = roomCount;
    t17 = journey;
    let t21;
    if ($[41] !== formatPrice || $[42] !== total) {
      t21 = formatPrice(total);
      $[41] = formatPrice;
      $[42] = total;
      $[43] = t21;
    } else {
      t21 = $[43];
    }
    if ($[44] !== t21 || $[45] !== total) {
      t4 = {
        value: total,
        formatted: t21
      };
      $[44] = t21;
      $[45] = total;
      $[46] = t4;
    } else {
      t4 = $[46];
    }
    t2 = perPersonPrice;
    t3 = formatPrice(perPersonPrice);
    $[2] = adultCount;
    $[3] = details.startDate;
    $[4] = details.tripInDays;
    $[5] = duration;
    $[6] = formatPrice;
    $[7] = futurePricingTiers;
    $[8] = isTemplateOrBlueprint;
    $[9] = items;
    $[10] = journey;
    $[11] = journeyType;
    $[12] = paxCount;
    $[13] = roomCount;
    $[14] = total;
    $[15] = unavailableDates;
    $[16] = urlPath;
    $[17] = user;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = tripInDaysLabel;
  } else {
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t14 = $[22];
    t15 = $[23];
    t16 = $[24];
    t17 = $[25];
    t2 = $[26];
    t3 = $[27];
    t4 = $[28];
    t5 = $[29];
    t6 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
    tripInDaysLabel = $[34];
  }
  let t18;
  if ($[47] !== t2 || $[48] !== t3) {
    t18 = {
      value: t2,
      formatted: t3
    };
    $[47] = t2;
    $[48] = t3;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t18 || $[51] !== t4) {
    t19 = {
      total: t4,
      perPerson: t18
    };
    $[50] = t18;
    $[51] = t4;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== details || $[54] !== tripInDaysLabel) {
    t20 = {
      ...details,
      tripInDaysLabel
    };
    $[53] = details;
    $[54] = tripInDaysLabel;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t13 || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== t17 || $[64] !== t19 || $[65] !== t20 || $[66] !== t5 || $[67] !== t6 || $[68] !== t7 || $[69] !== t8 || $[70] !== t9) {
    t21 = {
      user: t5,
      futurePricingTiers: t6,
      unavailableDates: t7,
      urlPath: t8,
      journeyType: t9,
      isTemplateOrBlueprint: t10,
      isStartDateInPast: t11,
      isLastMinute: t12,
      isBookedTrip: t13,
      hasSurpriseMeAccommodation: t14,
      paxCount: t15,
      roomCount: t16,
      ...t17,
      price: t19,
      details: t20
    };
    $[56] = t10;
    $[57] = t11;
    $[58] = t12;
    $[59] = t13;
    $[60] = t14;
    $[61] = t15;
    $[62] = t16;
    $[63] = t17;
    $[64] = t19;
    $[65] = t20;
    $[66] = t5;
    $[67] = t6;
    $[68] = t7;
    $[69] = t8;
    $[70] = t9;
    $[71] = t21;
  } else {
    t21 = $[71];
  }
  return t21;
}
function _temp3(item_0) {
  return item_0.body?.some(_temp2);
}
function _temp2(body) {
  return body.type === "accommodation" && body.defaultAccommodation.accommodation.title.includes("surprise me");
}
function _temp(item) {
  return item.type === "Stay";
}